import { render, staticRenderFns } from "./AppResourseNotFound.vue?vue&type=template&id=2e47e2d7&scoped=true"
import script from "./AppResourseNotFound.vue?vue&type=script&lang=ts"
export * from "./AppResourseNotFound.vue?vue&type=script&lang=ts"
import style0 from "./AppResourseNotFound.vue?vue&type=style&index=0&id=2e47e2d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47e2d7",
  null
  
)

export default component.exports